export const AUTOPLAY_YOUTUBE_VIMEO = 'autoplay=1'
export const BACKGROUND_VIMEO_VIDEO = '?transparent=0&'
export const TOKEN_NAME = 'token_flip'
export const RATING_HIGH_TO_LOW = 'high_to_low'
export const FIRST_PAGE = 1
export const LIMIT_QUERY_2 = 2
export const LIMIT_QUERY_3 = 3
export const LIMIT_QUERY_4 = 4
export const LIMIT_QUERY_5 = 5
export const LIMIT_QUERY_6 = 6
export const LIMIT_QUERY_20 = 20
export const PREFIX_YOUTUBE = 'https://www.youtube.com/embed/'
export const PREFIX_VIMEO = 'https://player.vimeo.com/video/'

export const BASE_PAY_TYPE_LIST = ['Day', 'Week', 'Month', 'Assignment']
export const PRODUCT_DURATION_TYPE_LIST = ['Day', 'Week', 'Month', 'Assignment']
export const RATING_BY_NUMBERS_LIST = [
  { 'name': '1+', value: 1 },
  { 'name': '2+', value: 2 },
  { 'name': '3+', value: 3 },
  { 'name': '4+', value: 4 },
  { 'name': '5', value: 5 }
]

export const SIGNUP_TAB_INDEX = {
  USER_INFO: 0,
  PASSWORD_USER: 1,
  TERMS_CONDITIONS: 2,
  VERIFY_EMAIL: 3,
  WELCOME: 4,
  SHOW_RESEND_TEXT: 5,
  SHOW_TAB_INDEX: 6,
  SHOW_BACK_BUTTON: 0
}

export const FILE_TYPE = {
  AVATAR_FILE: 1,
  PROFILE_VIDEO_FILE: 2,
  IDENTIFICATION_FILE: 3,
  CV_FILE: 4,
  ACADEMIC_FILE: 5
}

export const URL_FILE = {
  PROOF_OF_IDENTIFICATION_URL: 'proof_of_identification_url',
  CV_URL: 'cv_url',
  ACADEMIC_DOCUMENT_URL: 'academic_document_url',
  AVATAR_URL: 'avatar_url',
  PROFILE_VIDEO_URL: 'profile_video_url',
  YOUTUBE_URL: 'youtube_url'
}

export const NOTICE_TYPE = {
  ACCOUNTING: 'accounting',
  LEADERSHIP: 'leadership'
}

const fakeWindow = {
  atob() { },
  open() { },
  location: {},
  localStorage: {
    setItem() { },
    getItem() { },
    removeItem() { }
  },
  sessionStorage: {
    setItem() { },
    getItem() { },
    removeItem() { }
  }
}
export function isUndefined(value) {
  return typeof value === 'undefined'
}
export const $window = window !== undefined ? window : fakeWindow

export function getRedirectUri(uri) {
  try {
    return !isUndefined(uri)
      ? `${$window.location.origin}${uri}`
      : $window.location.origin
  } catch (e) { }

  return uri || null
}

export const getPlayerOptions = (width, height) => {
  let playerOptions = {
    controlBar: {
      volumePanel: { inline: false }
    },
    width: width.toString(),
    height: height.toString(),
    muted: false,
    language: 'en',
    playbackRates: [0.7, 1.0, 1.5, 2.0],
    sources: [{
      type: 'video/mp4',
      src: ''
    }]
  }
  return playerOptions
}

export const EDIT_PASSWORD_REGEX = '^((?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&]))(?=.{8,})'

export const ERROR_SELECT_BOX = 'Please select your option.'
export const NO_FILE_SELECTED = 'No file selected'
export const SIGNUP_ERROR_COMMON = 'There was a problem in sign up, please back to  user information tab and update info, or if the problem persists, please contact us.'
export const TALENT_CARD_CONFIRM_MAKE_OFFER = 'Are you sure you want to make an offer to this talent?'
export const TALENT_CARD_CONFIRM_CANCEL_OFFER = 'Are you sure you want to cancel an offer to this talent?'
export const TALENT_CARD_MAKE_OFFER_SUCCESS = 'Offer made to talent successfully'
export const TALENT_CARD_CANCEL_OFFER_SUCCESS = 'Offer to talent cancelled successfully'
export const MY_JOB_EMPLOYER_CONFIRM_DELETE_JOB = 'Are you sure you want to remove this job?'
export const MY_JOB_EMPLOYER_DELETE_JOB_SUCCESS = 'Job deleted successfully'
export const MY_JOB_EMPLOYER_ALERT_TALENT_PICKED = 'Some talents have already accepted the offer, so you cannot edit it.'
export const MY_JOB_EMPLOYER_CONFIRM_CONTACT_ADMINISTRATOR_TO_EDIT = 'All interested talents will be lost. Are you sure you want to edit this job?'
export const MY_JOB_TALENT_CONFIRM_DECLINE_OFFER = 'Are you sure you want to reject this job?'
export const MY_JOB_TALENT_CONFIRM_SUBMIT_PROJECT = 'Are you sure you want to cancel the submission for this project?'
export const MY_JOB_TALENT_CONFIRM_CANCEL_PENDING = 'Are you sure you want to remove this job?'
export const MY_JOB_TALENT_CANCEL_SUCCESS = 'Submitted job cancelled successfully'
export const EDIT_PASSWORD_PASSWORD_HINT = 'Password must include at least 8 letters, a number and a special character.'
export const EDIT_PASSWORD_PASSWORD_CHANGE_SUCCESS = 'The password has been changed successfully'
export const NOTIFICATION_SETTINGS_MISS_EMAIL = 'Please update your email first.'
export const NOTIFICATION_SETTINGS_UPDATE_SUCCESS = 'Notification settings updated successfully'
export const MAKE_OFFER_SUCCESS = 'Offer sent to the talent successfully.'
export const MAKE_OFFER_ERROR_EMPTY_SELECTED_JOB = 'Please choose the job to make an offer.'
export const MAKE_OFFER_ERROR_ISNOT_ENOUGH_BALANCE = "Your available balance isn't enough to cover this make offer. Please top up then try again!"
export const RESET_PASSWORD_SUCCESS = (email) => `An email was sent to ${email}`
export const RATING_SUCCESS = 'Rated successfully'
export const APPROVE_PENDING_JOB_SUCCESS = 'Job approved successfully'
export const DECLINE_JOB_SUCCESS = 'Job rejected successfully'
export const SUBMIT_JOB_SUCCESS = 'Submitted job successfully'
export const ACCEPTED_JOB_SUCCESSFULLY = 'Accepted job successfully'
export const EDIT_EDUCATION_SUCCESS = 'The education has been updated successfully'
export const UPLOAD_FAILED = 'Please upload again.'
export const PROFILE_EMPTY_IMAGE = 'Please select file image'
export const PROFILE_EMPTY_VIDEO = 'Please select file video'
export const EDIT_PROFILE_SUCCESS = 'The personal information has been updated successfully'
export const UPDATE_PROUND_SUCCESS = 'The leadership, awards and core competencies has been updated successfully'
export const UPLOAD_PDF_ERROR = (name) => `${name} is not a file PDF`
export const UPDATE_PROFILE_SUCCESS = 'The profile has been updated successfully.'
export const UPDATE_EMPLOYMENT_SUCCESS = 'The employment history has been updated successfully'
export const UPDATE_WORK_PORTFOLIO_SUCCESS = 'The work portfolio has been updated successfully'
export const SETTING_SUCCESS = 'Setting applied successfully'
export const ALERT_SETTINGS_ERROR = 'Please check your setting again.'
export const SEND_CONTACT_SUCCESS = 'Sent contact successfully'
export const INTERESTED_JOB_SUCCESS = 'The job has been added to your interests successfully.'
export const CANCEL_INTERESTED_JOB_SUCCESS = 'Interest job cancelled successfully'
export const POST_JOB_SUCCESS = 'Job posted successfully'
export const EDIT_JOB_SUCCESS = 'Edit job successfully'
export const SIGN_UP_INVALID_CODE = 'Invalid Confirm Code'
export const SECURITY_QUESTIONS_UPDATE_SUCCESS = 'Security questions updated successfully'
export const EDIT_PERSONAL_INFORMATION_INVALID_PHONE_NUMBER = 'Invalid Phone number'
export const SIGN_UP_PHONE_NUMBER_REQUIRED = 'The phone number field is required'
export const CREATE_BUSINESS_ACCOUNT_SUCCESS = 'The business account has been created successfully.'
export const EDIT_BUSINESS_ACCOUNT_SUCCESS = 'The business account has been updated successfully.'
export const BUSINESS_ACCOUNT_CONFIRM_DELETE = 'Are you sure you want to delete this business account?'
export const BUSINESS_ACCOUNT_DELETE_SUCCESS = 'Delete business account successfully'
export const JOB_DETAIL_PROMPT_UPDATE_PROFILE = 'Please update your profile before expressing interest in this job'
export const ADD_PAYMENT_ACCOUNT_SUCCESS = 'The payment account has added successfully'
export const TYPE_TOPUP_REQUIRED = 'The type field is required'
export const ACCOUNT_NAME_REQUIRED = 'The account name field is required'
export const ACCOUNT_NUMBER_REQUIRED = 'The account number field is required'
export const ACCOUNT_NUMBER_INVALID = 'Invalid account number'
export const AMOUNT_REQUIRED = 'The amount field is required'
export const AMOUNT_INVALID = 'Invalid amount'
export const OTP_REQUIRED = 'The OTP field is required'
export const OTP_INVALID = 'Invalid OTP'
export const TOPUP_VERIFY_FAIL = 'Verification failed. Please try again'
export const TOPUP_FAIL = 'Top up failed. Please try again'
export const TOPUP_SUCCESS = 'Top up successfully'
export const TOPUP_DOES_NOT_SUPPORT = "This bank doesn't support top up"
export const MOBILE_PAYMENT_REQUIRED = 'The mobile payment field is required'
export const BANK_PAYMENT_REQUIRED = 'The bank payment field is required'
export const EMAIL_REQUIRED = 'The email field is required'
export const EMAIL_INVALID = 'Invalid email'
export const FULL_NAME_REQUIRED = 'The full name field is required'
export const PAYMENT_TRANSFER_FAIL = 'Transfer failed. Please try again'
export const PAYMENT_TRANSFER_SUCCESS = 'Transferred successfully'
export const PAYMENT_TRANSFER_NOT_ENOUGH_BALANCE = "Your available balance isn't enough to make this transfer!"
export const EMAIL_EXISTS_MESSAGE = 'The email already exists'
export const PHONE_EXISTS_MESSAGE = 'The phone number already exists'
export const SIGN_UP_SUCCESS = 'User registered successfully'
export const POST_JOB_WITHOUT_LOGIN_CONFIRM = 'Your posted job is saved temporarily. Please login or register a new account to complete your job posting process'
export const INVITATION_CODE_INVALID = 'Invitation code is invalid'
export const SETTING_ROLE_SUCCESS = 'Set role successfully'
export const PAYMENT_DELETE_ACCOUNT_SUCCESS = 'Deleted successfully'
export const MOBILE_MONEY = 'Mobile Money'
export const STATUS_END_DATE = 'status-end-date'
export const ITEM_LIMIT = 1000
export const E_WALLET_TAB = {
  OVERVIEW: 'overview',
  TRANSACTIONS: 'transactions',
  TRANSFERS: 'transfers',
  ACCOUNT: 'account'
}
export const E_WALLET_FILTER = {
  ALL: 'all',
  YEAR: '1y',
  MONTH: '30d',
  WEEK: '7d',
  TODAY: '0d'
}
export const TYPE_PAYMENT = {
  BANK_ACCOUNT: 'bank_account',
  MOBILE_ACCOUNT: 'mobile_account',
  VISA_CARD: 'visa_card'
}

export const TYPE_PAYMENT_ACCOUNT_MODAL = {
  ADD: 'add',
  EDIT: 'edit'
}

export const ROLE_SETTING = {
  TALENT: 'talent',
  HIRING_ENTITY: 'employer',
  BOTH: 'both'
}

export const TRANSACTION_MODE = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing'
}
export const CARD_PAYMENT_REQUIRED = 'The card selection field is required'
export const CARD_HOLDER_NAME_REQUIRED = 'The card holder name field is required'
export const CARD_NUMBER_REQUIRED = 'The card number field is required'
export const EXPIRE_DATE_REQUIRED = 'The card expiration field is required'
export const COUNTRY_CODE_REQUIRED = 'The country field is required'
export const TOPUP_CVV_REQUIRED = 'The cvv field is required'
export const TOPUP_PIN_REQUIRED = 'The pin field is required'

export const CURRENCY_LIST = ['UGX', 'USD', 'SGX', 'EUR', 'GBP', 'GHS', 'NGN', 'XAF', 'SLL', 'TZS', 'XOF', 'ZAR']



// WEBPACK FOOTER //
// ./src/utils/constants.js